export const statusRelacionamentoEnum = {
    semRelacionamento: 0,
    negociacao: 2,
    vigente: 4,
    encerrado: 5,
};
